const questionsMockData = {
    questions: [
        {
            questionId: "sustainable_work_question",
            questionHeader: "Am I working sustainably?",
        },
        {
            questionId: "visible_enough_question",
            questionHeader: "Am I visible enough?",
        },
        {
            questionId: "focus_time_question",
            questionHeader: "Do I have enough focus time to produce high quality work?",
        },
        {
            questionId: "healthy_pace_question",
            questionHeader: "Am I working at a healthy pace?",
        },
        {
            questionId: "goals",
            questionHeader: "Am I achieving my goals?",
        },
    ],
};

export default questionsMockData;
